export const pillTitleStyles = {
  borderRadius: 'full',
  borderWidth: '1px',
  borderColor: 'volyx.primary',
  bg: 'volyx.bg',
  fontWeight: 'bold',
  color: 'volyx.primary',
  px: 4,
  py: 2,
  pointerEvents: 'none' as const,
};
